import { useCallback } from 'react';
import { isBefore } from 'date-fns';
import { store } from 'redux/store';
import { useSelector } from 'react-redux';
import {
  selectMFClassicComparatorInitialDateDiff,
  setInitialDateDiff as setInitialDateRedux,
  selectMFClassicComparatorFinalDateDiff,
  setFinalDateDiff as setFinalDateDiffRedux,
} from 'redux/reducers/meteorologyFieldsClassicComparatorControlPanelReducer';
import usePossibleIntervals from 'hooks/Meteorology/Fields/ClassicComparator/usePossibleIntervals';
import dateDiffToDate from 'helper/dateDiffToDate';
import simpleFormatDateDifference from 'helper/simpleFormatDateDifference';

export default function useClassicComparatorDates() {
  const { possibleIntervals } = usePossibleIntervals();
  const initialDateDiff = useSelector(selectMFClassicComparatorInitialDateDiff);
  const finalDateDiff = useSelector(selectMFClassicComparatorFinalDateDiff);
  const initialDate = dateDiffToDate(initialDateDiff, possibleIntervals);
  const finalDate = dateDiffToDate(finalDateDiff, possibleIntervals);

  const setInitialDate = useCallback((date: Date | null) => {
    const dateDiff = simpleFormatDateDifference(date);
    store.dispatch(setInitialDateRedux(dateDiff));

    if (date && finalDate && isBefore(finalDate, date)) {
      // nova inicial passou da final: empurra a final junto (período válido de 1 dia),
      // em vez de limpar o campo e o usuário perder a seleção sem aviso.
      store.dispatch(setFinalDateDiffRedux(dateDiff));
    }
  }, [finalDate]);
  const setFinalDate = useCallback((date: Date | null) => {
    const dateDiff = simpleFormatDateDifference(date);
    store.dispatch(setFinalDateDiffRedux(dateDiff));
  }, []);
  const resetPeriodDates = useCallback(() => {
    store.dispatch(setInitialDateRedux(undefined));
    store.dispatch(setFinalDateDiffRedux(undefined));
  }, []);

  return {
    initialDate,
    setInitialDate,
    finalDate,
    setFinalDate,
    possibleIntervals,
    resetPeriodDates,
  };
}
